import { useState, useEffect } from "react";
import { Cookie } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const KEY = "ors_cookie_consent";

export const CookieConsent = () => {
  const { t } = useLanguage();
  const c = t.cookie;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const decide = (val) => {
    localStorage.setItem(KEY, val);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent"
      className="fixed bottom-0 inset-x-0 z-[60] bg-[#0A2060] border-t border-white/15 backdrop-blur"
    >
      <div className="container-page py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4 justify-between">
        <p className="flex items-start gap-3 text-sm text-slate-300 leading-relaxed max-w-2xl">
          <Cookie className="h-5 w-5 text-[#CEA26B] shrink-0 mt-0.5" />
          {c.text}
        </p>
        <div className="flex items-center gap-3 shrink-0">
          <button
            onClick={() => decide("declined")}
            data-testid="cookie-decline"
            className="px-5 py-2.5 text-sm font-medium text-slate-300 border border-white/20 hover:bg-white/10 transition-colors"
          >
            {c.decline}
          </button>
          <button
            onClick={() => decide("accepted")}
            data-testid="cookie-accept"
            className="px-5 py-2.5 text-sm font-semibold bg-[#CEA26B] hover:bg-[#BE965D] text-[#01154F] transition-colors"
          >
            {c.accept}
          </button>
        </div>
      </div>
    </div>
  );
};
